import {ReadonlyDeep} from 'type-fest';
import {
  SlotStatus,
  WorkerEntity,
} from '../../../universal/features/api/entity/dashboard/worker/WorkerEntity';

export default (worker: ReadonlyDeep<WorkerEntity>) =>
  worker.slot_status === SlotStatus.Inactive || !worker.managed;
